// extracted by mini-css-extract-plugin
export var avatar = "_qy-3";
export var avatarContainer = "_qy-2";
export var avatarSpacer = "_qy-5";
export var avatarSpacerContainer = "_qy-4";
export var avatarStackContainer = "_qy-1";
export var bubble = "_qy-0";
export var remainderBubble = "_qy-6";